module.exports = __webpack_public_path__ + "assets/images/green-xmas-4.jpg?v=69d1e477";